<div class="addCoin animate__animated animate__fadeIn">

  <p class="subtitle">
    🚀 Catapult Your Coin to the Moon 🌙
  </p>
  <p>
    You are in the right place. Thousands of daily users can get to know your project
  </p>

  <div class="segment">
    <div class="row">
      <div class="col-lg-4 col-md-4">
        <div class="first">
          <h4>
            15.000 Daily Users
          </h4>
          <div class="banner">
            <h5>From all over the world</h5>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4">
        <div class="first">
          <h4>
            9.000 Coins Listed
          </h4>
          <div class="banner">
            <h5>On 7 Blockchains</h5>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4">
        <div>
          <h4>
            2.100.000 Users
          </h4>
          <div class="banner">
            <h5>And growing every day</h5>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="image">
    <img src="assets/images/graph.jpg" alt="">
  </div>

  <h2>
    Boost Your Coin 🚀
  </h2>

  <div class="segment">
    <div class="row">
      <div class="col-lg-4 col-md-4">
        <div class="first">
          <h4>
            1 Day
          </h4>

          <div class="banner">
            <h5>Featured coin</h5>
            <span>$20</span>
          </div>
          <div class="banner">
            <h5>Carousel banner</h5>
            <span>$25</span>
          </div>
          <div class="banner">
            <h5>Wide banner</h5>
            <span>$30</span>
          </div>
          <div class="banner">
            <h5>Popup</h5>
            <span>$100</span>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4">
        <div class="second">
          <h4>
            3 Days
          </h4>

          <div class="banner">
            <h5>Featured coin</h5>
            <span>$50</span>
          </div>
          <div class="banner">
            <h5>Carousel banner</h5>
            <span>$60</span>
          </div>
          <div class="banner">
            <h5>Wide banner</h5>
            <span>$75</span>
          </div>
          <div class="banner">
            <h5>Popup</h5>
            <span>$250</span>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-4">
        <h4>
          7 Days
        </h4>

        <div class="banner">
          <h5>Featured coin</h5>
          <span>$100</span>
        </div>
        <div class="banner">
          <h5>Carousel banner</h5>
          <span>$120</span>
        </div>
        <div class="banner">
          <h5>Wide banner</h5>
          <span>$150</span>
        </div>
        <div class="banner">
          <h5>Popup</h5>
          <span>$500</span>
        </div>
      </div>
    </div>

    <ul>
      <li>
        <span class="title">
          Payment:
        </span>
        <span class="text">
          BNB, BUSD, ETH, USDT, SOL, USDC
        </span>
      </li>
      <li>
        <span class="title">
          Carousel banner size:
        </span>
        <span class="text">
          320x200px
        </span>
      </li>
      <li>
        <span class="title">
          Wide banner size:
        </span>
        <span class="text">
          728x90px
        </span>
      </li>
      <li>
        <span class="title">
          Popup size:
        </span>
        <span class="text">
          320x200px
        </span>
      </li>
      <li>
        <span class="title">
          Disclaimer:
        </span>
        <span class="text">
          Prices are subject to change
        </span>
        <p class="custom">
          * For custom advertising inquires contact us.
        </p>
      </li>
    </ul>

    <div class="promoteCoin">
      <p>
        Don't be shy, contact us!
      </p>
      <a class="btn btn-primary-custom" routerLink="/contact"><i class="fa fa-pencil-square-o"></i> Contact Form</a>
      <a class="btn btn-primary-custom" href="mailto:contact@coincatapult.com" target="_blank" rel="nofollow noopener"><i class="fa fa-envelope-open-o"></i> Email</a>
      <a class="btn btn-primary-custom" href="https://t.me/coincatapult_marketing" target="_blank" rel="nofollow noopener"><i class="fa fa-telegram"></i> Telegram</a>
    </div>


  </div>


</div>
